import { z } from "zod"

import { calculateQuantityDifference } from "../../../utils"
import { TransferVarianceReason } from "../constants"

import { lpnSchema } from "./transfer"

const VARIANCE_COMMENTS_MAX_LENGTH = 255

const transferReceiveLotFormSchema = z.object({
  transferLotId: z.string(),
  qtyExpected: z.number(),
  qtyReceived: z.number().min(0, "Qty Received must be greater than or equal to 0").nullable(),
  varianceReason: z.nativeEnum(TransferVarianceReason),
  varianceComments: z
    .string()
    .max(VARIANCE_COMMENTS_MAX_LENGTH, `Variance Comments must not exceed ${VARIANCE_COMMENTS_MAX_LENGTH} characters`),
})

export const transferReceiveFormSchema = z.object({
  pallets: z.array(z.object({ referenceNbr: z.number(), lpn: lpnSchema, lots: z.array(transferReceiveLotFormSchema) })),
})

export type TransferReceiveFormValues = z.infer<typeof transferReceiveFormSchema>

export const transferConfirmReceivedSchema = transferReceiveFormSchema.superRefine(({ pallets }, ctx) => {
  pallets.forEach(({ lots }, palletIndex) => {
    lots.forEach(({ qtyReceived, qtyExpected, varianceReason }, lotIndex) => {
      if (qtyReceived === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["pallets", palletIndex, "lots", lotIndex, "qtyReceived"],
          message: "Qty Received is required",
        })
        return
      }

      const hasVariance = calculateQuantityDifference(qtyReceived, qtyExpected) !== 0
      const hasReason = !!varianceReason && varianceReason !== TransferVarianceReason.None

      if (hasVariance && !hasReason) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["pallets", palletIndex, "lots", lotIndex, "varianceReason"],
          message: "Variance Reason is required",
        })
      }
    })
  })
})
